import { axiosInstance } from '../../../../../Interceptors/axiosInterceptor';
import ApiUrlConstant from '../../../../../Shared/Utils/UrlConstants';

const Service = {
  verifyOtp: (reqData) => {
    return axiosInstance.post(ApiUrlConstant.verifyOtpService(), reqData);
  },
  verifyOtpLogin: (data) => {
    return axiosInstance.post(ApiUrlConstant.verifyOtpServiceLogin(), data);
  },
  otpSendonMail: (data) => {
    return axiosInstance.post(ApiUrlConstant.resendOtpService(), data);
  },
};

export default Service;
